import Vue from 'vue';
import App from './App';
import 'babel-polyfill';

import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueMoment from 'vue-moment';

import func from './plugins/preload.js'
import nodeWrap from '@/components/workflow/nodeWrap'
Vue.component('nodeWrap', nodeWrap); //初始化组件
import addNode from '@/components/workflow/addNode'
Vue.component('addNode', addNode); //初始化组件
Vue.prototype.$func = func;

import './permission'; // 权限
import './directives'; // 引入Dialog可拖拽
import store from './store/index';
import * as filters from './filters'; // 全局filter
import './styles/common.scss';
import './styles/font.css';
import router from './router/router';
import codeSetConst from './const/codeSet';
import loading from './util/loading';
import XEUtils from 'xe-utils';
import VXETable from 'vxe-table';
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'
import 'vxe-table/lib/index.css'
import './styles/public.scss'
import './styles/narrowUI.scss'
import './assets/icon/iconfont.js'
import VXEUtils from 'vxe-utils'
import echarts from 'echarts'

//结构图组件
import Vue2OrgTree from 'vue-tree-color'
Vue.use(Vue2OrgTree)

// mounts 可以设置['cookie', 'browse', 'locat']
Vue.use(VXEUtils, XEUtils, {mounts: ['cookie']})

Vue.use(Element);

import { message } from './resetMessage';
Vue.prototype.$message = message; //重写message提示框


Vue.use(VueMoment);
Vue.use(VXETable);
VXETable.use(VXETablePluginElement)

// 自定义全局的格式化处理函数
VXETable.formats.mixin({
  formatCode ({ cellValue }) {
    let dicts1 = JSON.parse(sessionStorage.getItem('dicts')).content;
    if (cellValue&&dicts1 && dicts1.codeMap) {
      if(cellValue ===0||cellValue =="0"){
        return "";
      }else {
        return dicts1.codeMap[cellValue ]? dicts1.codeMap[cellValue ]:cellValue ;
      }
    }else if(dicts1){
      return dicts1[cellValue ]
    }
  },
})

//Vue.prototype.getDicts = getDicts;
Vue.prototype.$Loading = loading;
Vue.prototype.$codeSetConst = codeSetConst;
Vue.prototype.$echarts = echarts


Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.directive('enterNumber', {
  bind: function (el, { value = 2 }) {
    el = el.nodeName == "INPUT" ? el : el.children[0]
    var RegStr = value == 0 ? `^[\\+\\-]?\\d+\\d{0,0}` : `^[\\+\\-]?\\d+\\.?\\d{0,${value}}`;
    el.addEventListener('keyup', function () {
      el.value = el.value.match(new RegExp(RegStr, 'g'));
      el.dispatchEvent(new Event('input'))
    })
  }
});

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    el.focus()
  }
});
new Vue({
  router,
  store,
  components: {
    nodeWrap,
    addNode,
  },
  render: h => h(App),
}).$mount('#app');

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'sockedMsgContent') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
};
